import { Box } from '@mantine/core';

import { CreditOptionsResponse, CreditResponse } from 'types';

import CreditDetails from './details';
import CreditPaymentStructure from './structure';

interface CreditPaymentProps {
  options: CreditOptionsResponse;
  credit: CreditResponse;
  readOnly?: boolean;
}

const CreditPayment = ({ options, credit, readOnly = false }: CreditPaymentProps) => {
  return (
    <Box p={'lg'}>
      <CreditDetails credit={credit} readOnly={readOnly} />
      <Box mt={64}>
        <CreditPaymentStructure options={options} credit={credit} readOnly={readOnly} />
      </Box>
    </Box>
  );
};

export default CreditPayment;
